import { render, staticRenderFns } from "./ClPricesHome.vue?vue&type=template&id=fc9620e4&"
import script from "./ClPricesHome.vue?vue&type=script&lang=js&"
export * from "./ClPricesHome.vue?vue&type=script&lang=js&"
import style0 from "./ClPricesHome.vue?vue&type=style&index=0&id=fc9620e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports